import { FeatureFlagContext, FeatureFlagProviderProps, featureFlags } from './FeatureFlag';

const FeatureFlagProvider = ({ environment, children }: FeatureFlagProviderProps) => {
  const currentFlags = featureFlags[environment] || {};

  return <FeatureFlagContext.Provider value={currentFlags}>{children}</FeatureFlagContext.Provider>;
};

export default FeatureFlagProvider;
